import { z } from 'zod'

export const invoiceSchema = z.object({
  customer_id: z.string().min(1, 'Customer is required'),
  invoice_number: z.string().min(1, 'Invoice number is required'),
  invoice_date: z.string().min(1, 'Invoice date is required'),
  due_date: z.string().min(1, 'Due date is required'),
  original_amount: z.number().min(0.01, 'Amount must be greater than 0'),
  status: z.enum(['outstanding', 'partial_payment', 'paid', 'disputed', 'written_off']).default('outstanding'),
  description: z.string().optional().nullable(),
})

export type InvoiceFormData = z.infer<typeof invoiceSchema>
